import {Component, OnInit} from '@angular/core';
import {RolesService} from '../../services/roles.service';
import {Router} from '@angular/router';
import {EventService} from '../../services/event.service';
import {Event} from '../../model/Event';

import {DashBlockInfosComponent} from "../../components/user/dash-block/dash-block-infos/dash-block-infos.component";
import {
  DashBlockTicketsComponent
} from "../../components/user/dash-block/dash-block-tickets/dash-block-tickets.component";
import {DashBlockFaqComponent} from "../../components/user/dash-block/dash-block-faq/dash-block-faq.component";
import {
  DashBlockFavoritesComponent
} from "../../components/user/dash-block/dash-block-favorites/dash-block-favorites.component";
import {
  DashBlockCommercialComponent
} from "../../components/user/dash-block/dash-block-commercial/dash-block-commercial.component";
import {DashBlockDpComponent} from "../../components/user/dash-block/dash-block-dp/dash-block-dp.component";
import {DashBlockCdtComponent} from "../../components/user/dash-block/dash-block-cdt/dash-block-cdt.component";
import {
  DashBlockPrestationsComponent
} from "../../components/user/dash-block/dash-block-prestations/dash-block-prestations.component";
import {DashBlockNewsComponent} from "../../components/user/dash-block/dash-block-news/dash-block-news.component";
import {EventBarComponent} from "../../components/user/event-bar/event-bar.component";
import {
  DashBlockRnComponent
} from "../../components/user/dash-block/dash-block-rn/dash-block-rn.component";

@Component({
    selector: 'app-dashboard',
    imports: [
    DashBlockInfosComponent,
    DashBlockTicketsComponent,
    DashBlockFaqComponent,
    DashBlockFavoritesComponent,
    DashBlockCommercialComponent,
    DashBlockDpComponent,
    DashBlockCdtComponent,
    DashBlockPrestationsComponent,
    DashBlockNewsComponent,
    EventBarComponent,
    DashBlockRnComponent
],
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  // We have to do this to conditionally display DP block (keep the grid)
  hasDp = true;
  event: Event = null;

  constructor(public rolesService: RolesService, private router: Router, private eventService: EventService) {
  }

  ngOnInit(): void {
    if (this.rolesService.isCollaborateur()) {
      this.router.navigate(['informations']);
    }
    this.eventService.getEvent().subscribe(e => {
      this.event = e;
    }, () => {
      // there is no event right now, nothing to do... just catch the error
    });
  }

}
